export default [
	{
		columnName: 'id',
		columnDisplayName: 'Id',
		display: false
	},
	{
		columnName: 'laborOpNumber',
		columnDisplayName: 'Labor Code',
		columnModifierName: 'labor-code',
		display: true,
		slot: 'laborOpNumber',
		isSortable: true
	},
	{
		columnName: 'description',
		columnDisplayName: 'Description',
		columnModifierName: 'description',
		display: true,
		slot: 'description',
		isSortable: true
	},
	{
		columnName: 'flatRateTime',
		columnDisplayName: 'Time',
		columnModifierName: 'flat-rate-time',
		display: true,
		slot: 'flatRateTime',
		isSortable: false
	},
	{
		columnName: 'defectCodes',
		columnDisplayName: 'Defect Codes',
		columnModifierName: 'defect-codes',
		display: true,
		slot: 'defectCodes',
		isSortable: false
	},
	{
		columnName: 'imported',
		columnDisplayName: '',
		columnModifierName: 'add-labor-code',
		display: true,
		slot: 'addLaborCode',
		isSortable: false
	}
];
